import { partition } from 'lodash';

// import { GetConferencesResults } from './type';

import { DynamicData } from '@domui-domain/type';
import { isPastConference } from '@domui-use-cases/districts';

export const getSplitConferences = (conferences: DynamicData) => {
  const [pastConferences, upcomingConferences] = partition(
    conferences,
    ({ endDate }) => isPastConference(endDate)
  );

  return { pastConferences, upcomingConferences };
};
